module.exports = __webpack_public_path__ + "img/ico-tooltip.dd13ef7f.svg";